export class Question {
    id: number;
    pollId: number;
    pollTitle: string;
    text: string;
    questionType: string;
}
